export default __webpack_public_path__ + "static/media/games_light.235c7893.png";